var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Test"},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"功能权限管理","name":"first"}},[_c('Set_permissions')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }